/**
 * @async
 * @function filterRoleGroups
 * @param { array } userGroups
 * @param { array } groups
 * @param { array } apps
 * @returns { Promise<Array> } _roleGroups
 */
function filterRoleGroups(userGroups, groups, apps) {
	let _roleGroups = [];

	for (let i = 0; i < userGroups.length; i++) {
		for (let j = 0; j < groups.length; j++) {
			if (userGroups[i].roleGroupId === groups[j].id) {
				for (let k = 0; k < apps.length; k++) {
					if (groups[j].appId === apps[k].id) {
						const tempObj = {
							id: groups[j].id,
							appName: apps[k].name,
						};
						_roleGroups.push(tempObj);
					}
				}
			}
		}
	}

	return _roleGroups;
}

export default filterRoleGroups;
